// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message__lGwGi {
  overflow: hidden;

  padding: 10px 16px;

  font-size: 14px;
  line-height: 20px;
  word-wrap: break-word;
}

.messageText__deMW1 {
  white-space: pre-wrap;
}

.userMessage__gTHq0,
.adminMessage__YsV4e {
  display: flex;
  justify-content: space-between;
}

.userMessage__gTHq0 {
  flex-direction: row-reverse;
}

.userMessage__gTHq0 .message__lGwGi {
  margin-right: 20px;
  margin-left: 16px;
}

.userMessage__gTHq0 .message__lGwGi, .userMessage__gTHq0 .message__lGwGi a {
  color: #fff;
}

.adminMessage__YsV4e .message__lGwGi {
  margin-right: 16px;
  margin-left: 20px;
  background-color: #f2f2f2;
}

.adminMessage__YsV4e .message__lGwGi, .adminMessage__YsV4e .message__lGwGi a {
  color: #262732;
}

.timeContainer___nu9R {
  display: flex;
}

.time__GohzX {
  align-self: flex-end;

  margin: 0 20px;

  font-size: 10px;
  line-height: 10px;
  color: #8c8c8c;
  white-space: nowrap;
}

.userMessage__gTHq0 .time__GohzX {
  margin-right: 0;
}

.adminMessage__YsV4e .time__GohzX {
  margin-left: 0;
}

.file__ZoG5T {
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.file__ZoG5T a {
  overflow: hidden;
  display: flex;

  max-width: 165px;
  margin-left: 6px;

  color: inherit;
  text-decoration-line: underline;
}

.fileName__NgoiD {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image__IajEB {
  margin: -16px;
  margin-top: 8px;
}

.image__IajEB img {
  max-width: 100%;
}

.replayContainer__al73R {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.replayLine__X9e6_ {
  width: 1px;
  margin-right: 8px;
}

.replayTitle__TmjFY,
.replayContent__NDbal {
  overflow: hidden;

  max-width: 180px;

  font-size: 14px;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.replayTitle__TmjFY {
  margin-bottom: 4px;
  font-weight: 600;
}

.menu__RrDIO.menu__RrDIO ul {
  padding: 6px 0;
}

.menu__RrDIO.menu__RrDIO li {
  width: 109px;
  height: 36px;
  min-height: auto;
  padding: 8px 16px;

  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  line-height: 20px;
  color: #1a2e35;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/Correspondence/Message.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;;EAEhB,kBAAkB;;EAElB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;;EAEpB,cAAc;;EAEd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;;EAEb,gBAAgB;EAChB,gBAAgB;;EAEhB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;;EAEhB,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;;EAEjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".message {\n  overflow: hidden;\n\n  padding: 10px 16px;\n\n  font-size: 14px;\n  line-height: 20px;\n  word-wrap: break-word;\n}\n\n.messageText {\n  white-space: pre-wrap;\n}\n\n.userMessage,\n.adminMessage {\n  display: flex;\n  justify-content: space-between;\n}\n\n.userMessage {\n  flex-direction: row-reverse;\n}\n\n.userMessage .message {\n  margin-right: 20px;\n  margin-left: 16px;\n}\n\n.userMessage .message, .userMessage .message a {\n  color: #fff;\n}\n\n.adminMessage .message {\n  margin-right: 16px;\n  margin-left: 20px;\n  background-color: #f2f2f2;\n}\n\n.adminMessage .message, .adminMessage .message a {\n  color: #262732;\n}\n\n.timeContainer {\n  display: flex;\n}\n\n.time {\n  align-self: flex-end;\n\n  margin: 0 20px;\n\n  font-size: 10px;\n  line-height: 10px;\n  color: #8c8c8c;\n  white-space: nowrap;\n}\n\n.userMessage .time {\n  margin-right: 0;\n}\n\n.adminMessage .time {\n  margin-left: 0;\n}\n\n.file {\n  display: flex;\n  align-items: center;\n  margin-top: 12px;\n}\n\n.file a {\n  overflow: hidden;\n  display: flex;\n\n  max-width: 165px;\n  margin-left: 6px;\n\n  color: inherit;\n  text-decoration-line: underline;\n}\n\n.fileName {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.image {\n  margin: -16px;\n  margin-top: 8px;\n}\n\n.image img {\n  max-width: 100%;\n}\n\n.replayContainer {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.replayLine {\n  width: 1px;\n  margin-right: 8px;\n}\n\n.replayTitle,\n.replayContent {\n  overflow: hidden;\n\n  max-width: 180px;\n\n  font-size: 14px;\n  line-height: 20px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.replayTitle {\n  margin-bottom: 4px;\n  font-weight: 600;\n}\n\n.menu.menu ul {\n  padding: 6px 0;\n}\n\n.menu.menu li {\n  width: 109px;\n  height: 36px;\n  min-height: auto;\n  padding: 8px 16px;\n\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n  line-height: 20px;\n  color: #1a2e35;\n}\n"],"sourceRoot":""}]);
// Exports
export var message = `message__lGwGi`;
export var messageText = `messageText__deMW1`;
export var userMessage = `userMessage__gTHq0`;
export var adminMessage = `adminMessage__YsV4e`;
export var timeContainer = `timeContainer___nu9R`;
export var time = `time__GohzX`;
export var file = `file__ZoG5T`;
export var fileName = `fileName__NgoiD`;
export var image = `image__IajEB`;
export var replayContainer = `replayContainer__al73R`;
export var replayLine = `replayLine__X9e6_`;
export var replayTitle = `replayTitle__TmjFY`;
export var replayContent = `replayContent__NDbal`;
export var menu = `menu__RrDIO`;
export default ___CSS_LOADER_EXPORT___;
